var _path, _ellipse, _ellipse2, _ellipse3, _path2, _path3, _path4, _rect, _rect2, _rect3, _path5, _path6, _path7, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _path8, _path9, _path10, _polygon, _polygon2, _path11, _polygon3, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _polygon4, _path20, _polygon5, _path21, _polygon6, _path22, _path23, _path24, _path25, _path26, _circle, _path27, _ellipse31, _path28, _path29, _path30, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _rect4, _rect5, _rect6, _polygon7, _circle2, _path38, _polygon8, _circle3, _path39, _path40, _path41, _path42, _ellipse49, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _ellipse58, _ellipse59, _ellipse60, _ellipse61, _ellipse62, _ellipse63, _ellipse64, _ellipse65, _path43, _path44, _path45, _ellipse66, _ellipse67, _ellipse68, _ellipse69, _ellipse70, _ellipse71, _ellipse72, _ellipse73, _ellipse74, _ellipse75, _ellipse76, _ellipse77, _ellipse78, _ellipse79, _ellipse80, _ellipse81, _ellipse82;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 824.77942,
    height: 512.17057,
    viewBox: "0 0 824.77942 512.17057",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M833.133,227.50812H367.84a1.807,1.807,0,0,1,0-3.61318H833.133a1.807,1.807,0,0,1,0,3.61318Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#cacaca"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.66752,
    cy: 10.82345,
    rx: 10.58751,
    ry: 10.82345,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.24253,
    cy: 10.82345,
    rx: 10.58751,
    ry: 10.82345,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.81755,
    cy: 10.82345,
    rx: 10.58751,
    ry: 10.82345,
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M811.11173,195.70663h-25.981a1.96762,1.96762,0,0,0,0,3.93446h25.981a1.96762,1.96762,0,0,0,0-3.93446Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M811.11173,203.091h-25.981a1.96762,1.96762,0,0,0,0,3.93446h25.981a1.96762,1.96762,0,0,0,0-3.93446Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M811.11173,210.46567h-25.981a1.96762,1.96762,0,0,0,0,3.93446h25.981a1.96762,1.96762,0,0,0,0-3.93446Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 530.94391,
    y: 60.01743,
    width: 43.78725,
    height: 9.36339,
    rx: 4.68169,
    fill: "#6c63ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 508.70587,
    y: 78.74421,
    width: 88.26334,
    height: 9.36339,
    rx: 4.68169,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 508.70587,
    y: 97.47098,
    width: 88.26334,
    height: 9.36339,
    rx: 4.68169,
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M381.98813,507.106H360.25669c-.584,0-3.80095-1.70175-3.80095-3.801V491.233c-.10394-9.13106,29.78879-9.72874,29.90155,0v12.072C386.35729,505.40425,384.08734,507.106,381.98813,507.106Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M383.11264,483.05018a8.31755,8.31755,0,0,0-3.29132-.47175,2.23284,2.23284,0,0,0,.80588-.47222,3.267,3.267,0,0,1-.60654-.08173,1.4183,1.4183,0,0,1-.60312-.26983.67044.67044,0,0,1-.2529-.58648c.04062-.27612.29862-.50343.27213-.78126-.03037-.3184-.39774-.47335-.59435-.72562a1.03455,1.03455,0,0,1,.10373-1.24117,2.13879,2.13879,0,0,1,.67239-.52266,2.51135,2.51135,0,0,0-1.32.01913,1.46224,1.46224,0,0,0,.52141-1.51926,2.23267,2.23267,0,0,0-1.54173-1.42863,6.59071,6.59071,0,0,0-2.17509-.17566c.62027-.19057.52676-1.16231.05264-1.60533s-1.15225-.628-1.59936-1.09828-.41093-1.47419.23325-1.55229l-.0792-.22917a2.47959,2.47959,0,0,0-3.28962,1.79232c-.118.7353.10187,1.54866-.26707,2.19557-.47037.82478-1.61218.91809-2.55725.82668a3.66914,3.66914,0,0,0-2.74222.37427,1.61759,1.61759,0,0,0,1.07989,2.85986,7.49409,7.49409,0,0,0-1.84244.24319l.57949.22459a.95148.95148,0,0,1,.349.196.32485.32485,0,0,1,.07789.36824c-.09266.168-.33206.1622-.52177.13366l-1.25985-.18953a.47831.47831,0,1,1-.47584.80518,1.83986,1.83986,0,0,1,.30806.50657.62277.62277,0,0,1-.0585.56923.81241.81241,0,0,1-.93817.11421c-.10255-.03942-.20574-.08534-.3097-.12734.00208.03645.00485.07294.00912.1095a1.74374,1.74374,0,0,0,.74329,1.19223,2.31234,2.31234,0,0,0-1.47506.77677,2.35284,2.35284,0,0,0-.09707,2.82155,4.11158,4.11158,0,0,0-2.02432-.33539,1.41318,1.41318,0,0,0-1.2405,1.4112c.1147.87822,1.20217,1.19932,2.08112,1.30819a85.10544,85.10544,0,0,0,20.81267-.0025,7.751,7.751,0,0,0,2.71365-.69034,2.79366,2.79366,0,0,0,1.57759-2.18273A2.83451,2.83451,0,0,0,383.11264,483.05018Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#6c63ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M388.2429,493.22383a1.50029,1.50029,0,0,0-1.46892-1.16307c-.668.01756-1.26508.49458-1.921.39015-.54469-.08672-.97255-.56219-1.52036-.4896-.5017.06648-.77145.55681-1.14605.82058h-.96094c-.37411-.29448-.558-.89114-1.07679-1.05843-.78158-.252-1.40863.62992-2.22718.78594a2.37174,2.37174,0,0,1-1.37367-.26231,4.10414,4.10414,0,0,0-1.32319-.448,1.09166,1.09166,0,0,0-1.06678.46843c.02543-.24955-.29885-.49425-.62816-.51a2.09362,2.09362,0,0,0-1.03742.31956,1.95969,1.95969,0,0,1-1.04377.29856c-.81773-.07121-1.21873-1.02669-2.041-1.03709-1.035-.01309-1.44908,1.46125-2.4726,1.33558-.53223-.06535-.81945-.54861-1.294-.75529a2.72135,2.72135,0,0,0-1.54773-.01511l-2.42078.45317a4.22938,4.22938,0,0,1-2.17115.02131c-.51925-.18785-1.0236-.59469-1.559-.43985-.46634.13486-.694.65719-1.18778.68434a2.32841,2.32841,0,0,1-.89316-.30568,1.37681,1.37681,0,0,0-1.47989.37329,8.39323,8.39323,0,0,0-.129,3.3733,3.2652,3.2652,0,0,0,.05643.71316l2.43475,9.74323c.28626,1.49428,1.02515,2.57473,2.54659,2.57473h23.66411a3.17145,3.17145,0,0,0,3.1148-2.57473l2.43474-9.74323c.00483-.02524.00794-.05032.01217-.0755A13.68657,13.68657,0,0,0,388.2429,493.22383Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M359.30983,492.49059l.47313,6.15c.15771,2.05-.07573,4.07155.082,6.12156.08882,1.1546.5688,2.33767.65763,3.49227.01045.13584.22361.137.21307,0l-.47313-6.15-.47312-6.15-.26648-3.46381c-.01045-.13584-.22361-.137-.21308,0Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.41944,492.73408l.18437,6.06033.18437,6.06033.10351,3.40229c.00416.13679.21725.13738.21307,0l-.18436-6.06033-.18437-6.06033-.10351-3.40229C363.62836,492.59729,363.41527,492.5967,363.41944,492.73408Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.40085,493.09764l-.05608,5.85687-.05573,5.82138-.0316,3.30114a.1066.1066,0,0,0,.21307,0l.05608-5.85687.05573-5.82137.0316-3.30114a.1066.1066,0,0,0-.21307,0Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4086,492.91848l.11661,5.9292.11591,5.89369.06564,3.3374a.1066.1066,0,0,0,.21308,0l-.11662-5.9292-.11591-5.8937-.06564-3.3374a.1066.1066,0,0,0-.21307,0Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.792,492.675l.13332,6.08733.13332,6.08733.07463,3.40748a.1066.1066,0,0,0,.21307,0l-.13332-6.08733-.13331-6.08733L375.005,492.675A.1066.1066,0,0,0,374.792,492.675Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.43074,492.85956l.4647,6.13349.46336,6.11582.26115,3.44677c.0103.13588.22345.137.21308,0l-.46471-6.13349-.46336-6.11581-.26115-3.44678C378.63352,492.72369,378.42036,492.72257,378.43074,492.85956Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.47409,493.57434l.2802,5.61207c.0934,1.87069-.3814,3.74137-.288,5.61206l.15734,3.15125c.00681.13647.21992.13729.21307,0-.0934-1.87068.3814-3.74137.288-5.61206l-.2802-5.61206-.15733-3.15126C382.68035,493.43788,382.46724,493.43706,382.47409,493.57434Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.03128,
    cy: 284.60667,
    rx: 0.81679,
    ry: 0.5682,
    fill: "#e6e6e6"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.21611,
    cy: 285.88512,
    rx: 0.81679,
    ry: 0.5682,
    fill: "#3f3d56"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.97155,
    cy: 288.6551,
    rx: 0.81679,
    ry: 0.5682,
    fill: "#ff6584"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.72575,
    cy: 289.61308,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#e6e6e6"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.00257,
    cy: 290.42106,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#3f3d56"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.42401,
    cy: 292.17169,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#ff6584"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191.55546,
    cy: 291.60178,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#e6e6e6"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 194.83227,
    cy: 292.40977,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#3f3d56"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.25371,
    cy: 294.16039,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#ff6584"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 365.99023,
    cy: 483.04162,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(-350.58275 586.65039) rotate(-82.15499)",
    fill: "#e6e6e6"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 364.74254,
    cy: 486.17747,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(-354.76664 588.12222) rotate(-82.15499)",
    fill: "#3f3d56"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 363.63324,
    cy: 481.40282,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(-350.99455 582.90035) rotate(-82.15499)",
    fill: "#ff6584"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 371.60121,
    cy: 481.33701,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(-344.04898 590.73692) rotate(-82.15499)",
    fill: "#e6e6e6"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 370.35352,
    cy: 484.47287,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(-348.23287 592.20875) rotate(-82.15499)",
    fill: "#3f3d56"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.24422,
    cy: 479.69822,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(-344.46079 586.98689) rotate(-82.15499)",
    fill: "#ff6584"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 373.1235,
    cy: 477.86754,
    rx: 0.51621,
    ry: 0.3591,
    transform: "matrix(0.13649, -0.99064, 0.99064, 0.13649, -339.29747, 589.24906)",
    fill: "#3f3d56"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 372.0142,
    cy: 473.09288,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(-335.52538 584.0272) rotate(-82.15499)",
    fill: "#ff6584"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 383.03246,
    cy: 218.81468,
    rx: 7.55666,
    ry: 5.25681,
    fill: "#e6e6e6"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 431.00081,
    cy: 230.64249,
    rx: 7.55666,
    ry: 5.2568,
    fill: "#3f3d56"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 363.97654,
    cy: 256.26941,
    rx: 7.55666,
    ry: 5.25681,
    fill: "#ff6584"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 471.14704,
    cy: 283.53121,
    rx: 4.77581,
    ry: 3.3223,
    fill: "#e6e6e6"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 501.46303,
    cy: 291.00639,
    rx: 4.77581,
    ry: 3.3223,
    fill: "#3f3d56"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 532.84737,
    cy: 461.89962,
    rx: 4.77581,
    ry: 3.3223,
    transform: "matrix(0.13649, -0.99064, 0.99064, 0.13649, -185.55644, 733.68966)",
    fill: "#e6e6e6"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 521.30422,
    cy: 490.91153,
    rx: 4.77581,
    ry: 3.3223,
    transform: "translate(-224.26441 747.3065) rotate(-82.15499)",
    fill: "#3f3d56"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 511.04134,
    cy: 446.73796,
    rx: 4.77581,
    ry: 3.3223,
    transform: "translate(-189.36632 698.99553) rotate(-82.15499)",
    fill: "#ff6584"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 584.75833,
    cy: 446.12917,
    rx: 4.77581,
    ry: 3.3223,
    transform: "translate(-125.10815 771.4969) rotate(-82.15499)",
    fill: "#e6e6e6"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 562.9523,
    cy: 430.96755,
    rx: 4.77581,
    ry: 3.3223,
    transform: "translate(-128.91808 736.8028) rotate(-82.15499)",
    fill: "#ff6584"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M768.07148,686.101a2.37426,2.37426,0,0,0,1.72072-4.11518c-.05988-.23795-.10283-.40881-.16267-.6468a6.37875,6.37875,0,0,1,11.82577-.11153c2.81389,6.5864,6.4557,13.40487,4.64454,20.65932,11.96317-25.35448,7.8948-56.89311-9.78512-78.57587a19.46,19.46,0,0,1-9.87909-13.02847c2.41861.81949,5.43412-1.1478,3.61562-3.69543-.78825-.9737-1.58412-1.9397-2.37229-2.91344,9.18738-9.78448,20.134,5.59326,10.02135,18.79932A76.124,76.124,0,0,1,786.25,635.84608a32.00679,32.00679,0,0,1,1.91086-14.86654c1.829-4.41229,5.25721-8.12833,8.27617-11.94276a6.57046,6.57046,0,0,1,11.7192,3.39451c-3.38753,1.11343-3.82762,6.00667.04733,6.67637a32.76792,32.76792,0,0,1-18.056,25.86764,76.42018,76.42018,0,0,1,4.17615,31.94258c1.74269-12.64919,15.32074-15.71884,24.8112-20.74628a3.69686,3.69686,0,0,1,5.638,3.74448,21.35333,21.35333,0,0,0-3.74272,1.97451,3.22718,3.22718,0,0,0,1.49926,5.89121c-4.7838,11.83964-17.15184,19.79006-29.85453,19.74531a78.56449,78.56449,0,0,1-5.27762,15.40705H768.54394c-.06762-.20948-.12843-.42577-.18927-.63524a21.42046,21.42046,0,0,0,5.21682-.31083c-4.617-5.46648-8.18769-8.25539-5.50057-15.88684Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#f2f2f2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M398.91724,685.81874a2.37426,2.37426,0,0,1-1.72072-4.11518l.16269-.6468a6.37875,6.37875,0,0,0-11.82575-.11153c-2.81387,6.58637-6.4557,13.40487-4.64454,20.65933-11.96317-25.35449-7.89479-56.89308,9.78514-78.57587a19.46025,19.46025,0,0,0,9.87911-13.02848c-2.41859.81949-5.43411-1.1478-3.61562-3.69543.78823-.9737,1.58412-1.93969,2.37227-2.91343-9.1874-9.78448-20.134,5.59325-10.02135,18.79932a76.12435,76.12435,0,0,0-8.54975,13.37322,32.00691,32.00691,0,0,0-1.91084-14.86654c-1.829-4.41229-5.25723-8.12833-8.27618-11.94276a6.57046,6.57046,0,0,0-11.71919,3.39456c3.38753,1.11343,3.82762,6.00667-.04731,6.67636a32.76787,32.76787,0,0,0,18.056,25.86765,76.42012,76.42012,0,0,0-4.17613,31.94257c-1.74267-12.64918-15.32075-15.7188-24.8112-20.74627a3.69685,3.69685,0,0,0-5.638,3.74447,21.3532,21.3532,0,0,1,3.74274,1.97452,3.22718,3.22718,0,0,1-1.49925,5.8912c4.78378,11.83969,17.15182,19.79007,29.85451,19.74531A78.56645,78.56645,0,0,0,379.5915,702.652h18.85333c.06761-.20947.12842-.42577.18924-.63524a21.4209,21.4209,0,0,1-5.21682-.31082c4.617-5.46649,8.18769-8.25539,5.50059-15.88685Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#f2f2f2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M446.15277,465.09981l-2.00534-11.62342,30.48767-13.767,6.5841-11.65706a5.66782,5.66782,0,1,1,8.37091,3.76207l-10.83087,16.745Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#a0616a"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "248.789 262.573 262.518 255.561 266.153 269.208 256.616 276.277 248.789 262.573",
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "217.98 494.537 226.281 494.537 230.23 462.517 217.979 462.517 217.98 494.537",
    fill: "#a0616a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M417.14051,688.30825v-5.62782l-2.1824.13331-8.88379.52627-2.05607.1263-1.57184,18.84829-.08421,1.01047h5.89444l.18948-1.00345.85607-4.56121,2.21045,4.56121.48419,1.00345H427.6242a3.531,3.531,0,0,0,3.50862-3.51563C431.79249,696.72892,418.79658,690.0696,417.14051,688.30825Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "119.64 464.649 126.427 469.429 148.096 445.527 138.079 438.471 119.64 464.649",
    fill: "#a0616a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M316.59376,664.0449l3.24114-4.60083-1.86091-1.14788-7.56569-4.68605-1.75357-1.08087-12.14,14.50346-.6508.77758,4.81878,3.39472.7328-.71121,3.32671-3.23581-.8198,5.00185-.18207,1.09919,12.77554,9a3.531,3.531,0,0,0,4.893-.85342C323.72231,679.36713,316.93322,666.43852,316.59376,664.0449Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M418.91247,480.32991,408.22718,475.335l-21.30853,25.78715-12.9793,3.28256a5.66782,5.66782,0,1,0,1.4253,9.06607l19.00586-6.03988Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#a0616a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M408.13987,521.86767s-17.53182,11.41606-12.896,19.002c.1599.26166-37.34377,52.32876-37.34377,52.32876l-42.05444,45.33995,14.45621,13.142s39.95188-41.60269,46.65415-48.62546,35.97662-42.15617,35.97662-42.15617l1.07684,43.41912-11.20685,60.166,16.73311-1.06093,16.28654-60.36154,6.01161-68.3742Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M420.62785,453.35273l-7.37243,5.58708-8.40312,17.93467,8.08032,10.97411s6.79693,11.7796-4.08257,23.18738-19.23383,23.5919-10.52584,23.15689,43.97645,17.50324,44.20853,2.80687.70172-25.96374.70172-25.96374l9.24659-23.45258s5.50891-13.99071,1.64115-18.1787-9.04641-9.53961-9.04641-9.53961l-9.41756-9.41757h-8.50359Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M434.39039,418.89334c16.53951,9.41165,2.9614,34.24428-13.88647,25.40159C403.965,434.8836,417.54308,410.051,434.39039,418.89334Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#a0616a"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M443.2345,424.11179c-1.15891,1.50729-3.58015.80054-8.32169,1.87609a19.7661,19.7661,0,0,0-.55292-4.77187,13.43211,13.43211,0,0,1-2.26478,5.37027c-4.11719.45661.92992,12.96442-1.17814,22.16057-2.71614-19.4009-8.429-14.318-5.54289-10.4699,1.84764,2.46351.61587,9.854-4.927,6.15875-9.14553,4.3465-22.17155-17.24454-7.73473-27.3704-.258-5.4733,5.83211-6.33795,9.58235-4.65515C431.396,405.63029,441.794,414.3176,443.2345,424.11179Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M400.79774,409.95522c-3.6823,22.64008-23.41918-4.16373-32.69934,18.11636-2.91781,8.06853,2.08839,13.8405,5.255,20.53776.72273,5.50392-6.43744,8.29634-7.18742,13.36268-.20874,11.61513,18.53019,10.90437,23.7688,3.57625,5.38268-7.67126-1.045-17.96352,2.19038-26.1976,4.54733-11.43186,23.04036-11.51678,24.65143-24.81676C413.6565,410.09078,405.26658,405.002,400.79774,409.95522Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M415.71473,412.16757c-.12045.05073-.24093.10142-.3487.1585h-.00636c-.10142.05073-.20289.10142-.30432.15849-.0127.00636-.019.0127-.03171.01906-.13315-.12682-.26628-.25364-.40577-.38047a1.466,1.466,0,0,0,.02535.62132l.019.07613c.12681.13311.25993.25992.39943.39308.12682-.09512.24728-.19654.37406-.29166.07612-.06338.1522-.12681.23462-.1902.01265-.16486.03168-.35506.05069-.56429Zm3.81686-7.05036c-2.82776-.64671-3.74077,3.04966-4.0134,4.83126-1.02712-6.467-5.30044-4.43182-3.82314-.019a9.88,9.88,0,0,0,2.1747,3.49983c.13315.15216.279.30432.43112.45653-.17119.88761.69111.65936,1.85768-.1585a15.53948,15.53948,0,0,0,2.3776-2.086C420.863,409.20032,422.67636,405.93508,419.53159,405.11721Zm.08877,3.6393a22.15626,22.15626,0,0,1-2.92284,3.10039q-.50411.4565-1.02712.875c-.00636.05705-.00636.10777-.0127.15216a1.15893,1.15893,0,0,1-.08877.17751c-.35506.64038-.7545.29168-.90666-.24089-.0127-.01906-.03169-.03813-.04438-.05708a8.935,8.935,0,0,1-1.31244-1.73722c-2.61853-4.53964,1.59775-7.62734,1.38852.84957a.80308.80308,0,0,0-.07608.24728,1.466,1.466,0,0,0,.02535.62132l.019.07613c.12681.13311.25993.25992.39943.39308.12682-.09512.24728-.19654.37406-.29166.07612-.06338.1522-.12681.23462-.1902.01265-.16486.03168-.35506.05069-.56429v-.00634c.16486-1.69918.615-4.7552,1.44563-5.58576,1.826-1.40123,4.19082.1141,2.45362,2.181Zm-3.90561,3.41106c-.12045.05073-.24093.10142-.3487.1585h-.00636c-.10142.05073-.20289.10142-.30432.15849-.0127.00636-.019.0127-.03171.01906-.13315-.12682-.26628-.25364-.40577-.38047a1.466,1.466,0,0,0,.02535.62132l.019.07613c.12681.13311.25993.25992.39943.39308.12682-.09512.24728-.19654.37406-.29166.07612-.06338.1522-.12681.23462-.1902.01265-.16486.03168-.35506.05069-.56429Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "575.914 495.867 567.795 497.714 556.805 467.275 568.789 464.549 575.914 495.867",
    fill: "#ffb6b6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M766.22463,697.29514,741.25669,702.976l-.07187-.31576a9.96713,9.96713,0,0,1,7.50665-11.92952l.0006-.00012,3.77331-4.49783,9.29671,1.52407,2.17953-.49591Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#2f2e41"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "681.791 479.866 674.779 484.356 654.124 459.443 664.474 452.816 681.791 479.866",
    fill: "#ffb6b6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M874.81934,680.04709l-21.565,13.80661-.17463-.27268a9.96716,9.96716,0,0,1,3.01936-13.76759l.00052-.00032,2.02561-5.51044,9.26306-1.71687,1.88251-1.20523Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#2f2e41"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "570.51 344.239 564.402 360.169 535.746 416.693 560.925 482.447 573.92 479.017 563.21 416.693 593.938 379.356 611.779 417.718 663.033 474.228 674.861 466.343 636.749 407.861 611.37 333.696 570.51 344.239",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M789.42894,462.12017l-10.05536-10.80336-17.24889-2.373-21.135,14.79581.21289,16.377,10.44787,38.59092s-3.97962,27.72575,7.136,27.44769,17.17441-5.81981,21.70169-4.6917,23.77233,5.92916,24.992.90022,7.70269-1.42814,7.41809-6.18548S795.3477,497.129,795.3477,497.129l3.02148-24.138a9.69078,9.69078,0,0,0-8.41208-10.8194q-.26338-.033-.5282-.05148Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M858.81984,530.18706a6.1592,6.1592,0,0,1-7.43457-5.82451L805.153,506.16068l8.79835-7.20822,43.83031,18.97962a6.19261,6.19261,0,0,1,1.03815,12.255Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#ffb6b6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M793.33673,464.1229s-7.87594-.06064-8.84294,8.90431,15.54594,31.70181,18.09778,35.44619c.79908,1.17251,4.23281,2.5064,8.57287,3.78565,1.94844.5743,4.07953,1.1376,6.23692,1.67035,1.24843.30827,1.80647,2.37764,3.04218,2.66167,1.22894.28247,3.13583-1.22027,4.29241-.96927,5.48982,1.19138,9.82872,1.9863,9.82872,1.9863l10.264-6.99505c-5.1782-7.64525-15.0834-10.7731-26.30525-12.64261Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M677.45042,422.48949a6.15921,6.15921,0,0,0,8.07973,4.89033l33.3937,36.79118,3.6256-10.78073L689.279,419.12078a6.19261,6.19261,0,0,0-11.82858,3.36873Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#ffb6b6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M762.422,460.33579s2.84566,7.34415-5.196,11.423-35.15264-3.3128-39.558-4.37337c-1.37949-.3321-3.84286-3.071-6.57606-6.67687-1.227-1.61883-2.50848-3.41238-3.77063-5.2413-.73037-1.05839-2.86326-.84749-3.56648-1.90256-.69934-1.0493.03076-3.36476-.61351-4.35753-3.05814-4.71224-5.338-8.48848-5.338-8.48848l2.90726-12.07589c8.98352,2.13544,15.4162,10.29122,21.13836,20.12391Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 582.99645,
    cy: 236.7599,
    r: 16.4118,
    fill: "#ffb6b6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M789.82748,420.38678a8.462,8.462,0,0,0-8.10656-3.95061,11.07022,11.07022,0,0,0-18.54865-6.457,3.44233,3.44233,0,0,0-3.3664-.33689,7.09791,7.09791,0,0,0-2.735,2.19529,15.93015,15.93015,0,0,0-2.22906,16.20615c-.38382-1.39533,1.01453-2.708,2.42743-3.02112,1.41278-.31311,2.89479-.01689,4.3275-.22079,1.83631-.26129,3.487-1.32655,5.32619-1.56629a12.12544,12.12544,0,0,1,4.60745.59209,12.49281,12.49281,0,0,0,4.6056.61848c1.548-.18381,3.54194,5.68253,3.51519,9.8144-.00509.783.15617,1.78836.9214,1.95448.94238.20462,1.48842-1.096,2.3854-1.45042a1.6594,1.6594,0,0,1,2.03535,1.08232,2.70534,2.70534,0,0,1-.51653,2.4227,7.99476,7.99476,0,0,1-1.93825,1.68137l.36942.30724a2.19813,2.19813,0,0,0,2.77479.34471,5.9886,5.9886,0,0,0,1.99223-2.26843,26.69345,26.69345,0,0,0,3.6542-8.75633A12.75292,12.75292,0,0,0,789.82748,420.38678Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#2f2e41"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 598.84209,
    cy: 414.03077,
    rx: 4.77581,
    ry: 3.3223,
    transform: "translate(-81.14876 757.73168) rotate(-82.15499)",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M870.69214,526.5857H848.96071c-.584,0-3.801-1.70175-3.801-3.801v-12.072c-.10393-9.13106,29.78879-9.72874,29.90155,0v12.072C875.0613,524.884,872.79135,526.5857,870.69214,526.5857Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#e6e6e6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M871.81665,502.52988a8.31752,8.31752,0,0,0-3.29132-.47175,2.23276,2.23276,0,0,0,.80588-.47222,3.267,3.267,0,0,1-.60654-.08173,1.41836,1.41836,0,0,1-.60312-.26983.67049.67049,0,0,1-.2529-.58648c.04062-.27612.29862-.50343.27213-.78126-.03037-.3184-.39774-.47335-.59435-.72562a1.03456,1.03456,0,0,1,.10374-1.24117,2.13864,2.13864,0,0,1,.67238-.52266,2.51135,2.51135,0,0,0-1.32.01913,1.46224,1.46224,0,0,0,.52141-1.51926,2.23267,2.23267,0,0,0-1.54173-1.42863,6.59071,6.59071,0,0,0-2.17509-.17566c.62027-.19057.52676-1.16231.05264-1.60533s-1.15225-.628-1.59935-1.09828-.41093-1.47419.23324-1.55229l-.07919-.22917a2.4796,2.4796,0,0,0-3.28963,1.79232c-.118.7353.10188,1.54866-.26706,2.19557-.47038.82478-1.61219.91809-2.55726.82668a3.66914,3.66914,0,0,0-2.74222.37427,1.61759,1.61759,0,0,0,1.07989,2.85986,7.49362,7.49362,0,0,0-1.84244.24319l.57949.22459a.95148.95148,0,0,1,.349.196.32485.32485,0,0,1,.07789.36824c-.09266.168-.332.1622-.52177.13366l-1.25985-.18953a.47831.47831,0,1,1-.47583.80518,1.83982,1.83982,0,0,1,.308.50657.62277.62277,0,0,1-.0585.56923.8124.8124,0,0,1-.93817.11421c-.10255-.03942-.20574-.08534-.3097-.12734.00208.03645.00486.07294.00912.1095a1.74377,1.74377,0,0,0,.74329,1.19223,2.31234,2.31234,0,0,0-1.47506.77677,2.35285,2.35285,0,0,0-.09707,2.82155,4.11158,4.11158,0,0,0-2.02432-.33539,1.41317,1.41317,0,0,0-1.24049,1.4112c.11469.87822,1.20216,1.19932,2.08111,1.30819a85.10544,85.10544,0,0,0,20.81267-.0025,7.75106,7.75106,0,0,0,2.71366-.69034,2.79367,2.79367,0,0,0,1.57758-2.18273A2.83451,2.83451,0,0,0,871.81665,502.52988Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#6c63ff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M876.94691,512.70353a1.50029,1.50029,0,0,0-1.46892-1.16307c-.668.01756-1.26508.49458-1.921.39015-.54469-.08672-.97255-.56219-1.52036-.4896-.5017.06648-.77144.55681-1.14605.82058h-.96094c-.37411-.29448-.558-.89114-1.07679-1.05843-.78158-.252-1.40863.62992-2.22718.78594a2.37174,2.37174,0,0,1-1.37367-.26231,4.10414,4.10414,0,0,0-1.32319-.448,1.09166,1.09166,0,0,0-1.06678.46843c.02544-.24955-.29884-.49425-.62815-.51a2.09356,2.09356,0,0,0-1.03742.31956,1.95974,1.95974,0,0,1-1.04377.29856c-.81774-.07121-1.21874-1.02669-2.041-1.03709-1.035-.01309-1.44909,1.46125-2.47261,1.33558-.53223-.06535-.81945-.54861-1.294-.75529a2.72135,2.72135,0,0,0-1.54773-.01511l-2.42078.45317a4.22938,4.22938,0,0,1-2.17115.02131c-.51925-.18785-1.0236-.59469-1.559-.43985-.46634.13486-.694.65719-1.18778.68434a2.32847,2.32847,0,0,1-.89316-.30568,1.37681,1.37681,0,0,0-1.47989.37329,8.39341,8.39341,0,0,0-.129,3.3733,3.26582,3.26582,0,0,0,.05643.71316l2.43475,9.74323c.28626,1.49428,1.02515,2.57473,2.5466,2.57473h23.6641a3.17144,3.17144,0,0,0,3.1148-2.57473l2.43474-9.74323c.00483-.02524.00794-.05032.01217-.0755A13.68611,13.68611,0,0,0,876.94691,512.70353Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M848.01385,511.97029l.47312,6.15c.15772,2.05-.07573,4.07155.082,6.12156.08882,1.1546.5688,2.33767.65763,3.49227.01045.13584.22361.137.21308,0l-.47313-6.15-.47313-6.15-.26648-3.46381c-.01045-.13584-.22361-.137-.21307,0Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.12346,512.21378l.18437,6.06033.18437,6.06033.1035,3.40229c.00416.13679.21726.13738.21308,0l-.18437-6.06033-.18437-6.06033-.10351-3.40229C852.33237,512.077,852.11928,512.0764,852.12346,512.21378Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.10486,512.57734l-.05607,5.85687-.05574,5.82137-.0316,3.30115a.1066.1066,0,0,0,.21307,0l.05608-5.85687.05573-5.82137.0316-3.30114a.1066.1066,0,0,0-.21307,0Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.11261,512.39818l.11661,5.9292.11592,5.89369.06563,3.3374a.1066.1066,0,0,0,.21308,0l-.11661-5.9292-.11592-5.8937-.06564-3.3374a.1066.1066,0,0,0-.21307,0Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.496,512.15471l.13332,6.08733.13332,6.08733.07463,3.40748a.1066.1066,0,0,0,.21308,0l-.13332-6.08733-.13332-6.08733-.07463-3.40748A.1066.1066,0,0,0,863.496,512.15471Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.13475,512.33926l.4647,6.13349.46337,6.11582.26114,3.44677c.0103.13588.22346.137.21308,0l-.4647-6.13349L867.609,515.786l-.26115-3.44678C867.33753,512.20339,867.12437,512.20227,867.13475,512.33926Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.1781,513.054l.2802,5.61207c.0934,1.87069-.3814,3.74137-.288,5.61206l.15734,3.15125c.00681.13647.21993.13729.21307,0-.0934-1.87068.3814-3.74137.288-5.61206l-.28019-5.61206-.15734-3.15126C871.38437,512.91758,871.17125,512.91676,871.1781,513.054Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 670.73529,
    cy: 304.08637,
    rx: 0.81679,
    ry: 0.5682,
    fill: "#e6e6e6"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 675.92012,
    cy: 305.36482,
    rx: 0.81679,
    ry: 0.5682,
    fill: "#3f3d56"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 668.67557,
    cy: 308.13479,
    rx: 0.81679,
    ry: 0.5682,
    fill: "#ff6584"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 675.42977,
    cy: 309.09278,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#e6e6e6"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 678.70658,
    cy: 309.90076,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#3f3d56"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 674.12802,
    cy: 311.65139,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#ff6584"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 680.25947,
    cy: 311.08148,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#e6e6e6"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 683.53628,
    cy: 311.88946,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#3f3d56"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 678.95772,
    cy: 313.64009,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#ff6584"
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 854.69424,
    cy: 502.52132,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(52.1188 1087.60143) rotate(-82.15499)",
    fill: "#e6e6e6"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 853.44656,
    cy: 505.65717,
    rx: 0.51621,
    ry: 0.3591,
    transform: "matrix(0.13649, -0.99064, 0.99064, 0.13649, 47.93491, 1089.07325)",
    fill: "#3f3d56"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 852.33726,
    cy: 500.88252,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(51.707 1083.85139) rotate(-82.15499)",
    fill: "#ff6584"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 860.30522,
    cy: 500.81671,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(58.65257 1091.68796) rotate(-82.15499)",
    fill: "#e6e6e6"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 859.05754,
    cy: 503.95257,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(54.46867 1093.15979) rotate(-82.15499)",
    fill: "#3f3d56"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 857.94824,
    cy: 499.17792,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(58.24076 1087.93792) rotate(-82.15499)",
    fill: "#ff6584"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 861.82751,
    cy: 497.34724,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(63.40408 1090.20009) rotate(-82.15499)",
    fill: "#3f3d56"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 860.71822,
    cy: 492.57258,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(67.17617 1084.97823) rotate(-82.15499)",
    fill: "#ff6584"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.8762,704.05472c-.76734,2.2727-823.95154.81158-824.77942-1.45551C188.8631,700.321,1012.04722,701.78207,1012.8762,704.05472Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#ccc"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M508.40841,585.93528a26.16382,26.16382,0,1,1,26.16383-26.16382A26.16383,26.16383,0,0,1,508.40841,585.93528Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#e6e6e6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M518.732,557.19061h-7.74261v-7.74272a2.58093,2.58093,0,0,0-5.16187,0v7.74272h-7.74272a2.5809,2.5809,0,0,0,0,5.16179h7.74272v7.74271a2.58094,2.58094,0,0,0,5.16187,0V562.3524H518.732a2.5809,2.5809,0,1,0,0-5.16179Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M584.95581,585.93528a26.16382,26.16382,0,1,1,26.16383-26.16382A26.16383,26.16383,0,0,1,584.95581,585.93528Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#e6e6e6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M595.27936,557.19061h-20.6472a2.5809,2.5809,0,0,0,0,5.16179h20.6472a2.5809,2.5809,0,1,0,0-5.16179Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M661.50321,585.93528A26.16382,26.16382,0,1,1,687.667,559.77146,26.16383,26.16383,0,0,1,661.50321,585.93528Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#6c63ff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M676.22248,558.52856l-7.41734-10.82634a2.19976,2.19976,0,0,0-3.6294,2.48662l4.79705,7.00173H651.17958a2.5809,2.5809,0,1,0,0,5.16179h19.02923l-5.03307,7.34623a2.19977,2.19977,0,0,0,3.6294,2.48663l7.41734-10.82635a2.90267,2.90267,0,0,0,0-2.83031Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 244.2591,
    y: 83.4259,
    width: 43.78725,
    height: 9.36339,
    rx: 4.68169,
    fill: "#6c63ff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 222.02106,
    y: 102.15268,
    width: 88.26334,
    height: 9.36339,
    rx: 4.68169,
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 222.02106,
    y: 120.87945,
    width: 88.26334,
    height: 9.36339,
    rx: 4.68169,
    fill: "#e6e6e6"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "300.737 221.406 298.737 221.406 298.737 146.363 156.08 146.363 156.08 144.363 300.737 144.363 300.737 221.406",
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.79009,
    cy: 139.54652,
    r: 27.78,
    fill: "#e6e6e6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M318.0971,347.02865a3.08927,3.08927,0,0,1-2.47187-1.23631l-7.57881-10.10525a3.09007,3.09007,0,1,1,4.94423-3.70792l4.95832,6.61058,12.7348-19.10194a3.0902,3.0902,0,1,1,5.1424,3.42827l-15.15762,22.73643a3.09145,3.09145,0,0,1-2.48544,1.37513C318.15444,347.02814,318.12577,347.02865,318.0971,347.02865Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#fff"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "489.171 217.45 487.171 217.45 487.171 140.407 631.828 140.407 631.828 142.407 489.171 142.407 489.171 217.45",
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 654.01074,
    cy: 135.59052,
    r: 27.78,
    fill: "#e6e6e6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M838.31775,343.07265a3.08925,3.08925,0,0,1-2.47187-1.23631l-7.57881-10.10525a3.09007,3.09007,0,1,1,4.94423-3.70792l4.95832,6.61058,12.7348-19.10194a3.0902,3.0902,0,1,1,5.1424,3.42827L840.8892,341.69651a3.09148,3.09148,0,0,1-2.48545,1.37513C838.37508,343.07214,838.34642,343.07265,838.31775,343.07265Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M496.78308,423.297H475.05165c-.584,0-3.801-1.70175-3.801-3.801V407.424c-.10393-9.13106,29.78879-9.72873,29.90155,0v12.072C501.15224,421.59522,498.88229,423.297,496.78308,423.297Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#e6e6e6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M497.90759,399.24114a8.31749,8.31749,0,0,0-3.29131-.47174,2.233,2.233,0,0,0,.80587-.47223,3.26611,3.26611,0,0,1-.60654-.08173,1.41827,1.41827,0,0,1-.60312-.26982.6705.6705,0,0,1-.2529-.58648c.04062-.27612.29863-.50344.27213-.78126-.03036-.3184-.39773-.47335-.59434-.72563a1.03452,1.03452,0,0,1,.10373-1.24116,2.1385,2.1385,0,0,1,.67238-.52266,2.51135,2.51135,0,0,0-1.32.01913,1.46224,1.46224,0,0,0,.52141-1.51926,2.23267,2.23267,0,0,0-1.54173-1.42864,6.591,6.591,0,0,0-2.17509-.17565c.62028-.19057.52677-1.16231.05264-1.60533s-1.15225-.628-1.59935-1.09828-.41093-1.4742.23324-1.5523l-.07919-.22916a2.4796,2.4796,0,0,0-3.28963,1.79232c-.118.7353.10188,1.54865-.26706,2.19557-.47038.82478-1.61218.91808-2.55726.82667a3.66911,3.66911,0,0,0-2.74221.37428,1.61759,1.61759,0,0,0,1.07988,2.85986,7.49374,7.49374,0,0,0-1.84244.24319l.57949.22459a.95145.95145,0,0,1,.349.196.32485.32485,0,0,1,.07788.36824c-.09265.168-.332.1622-.52177.13366l-1.25984-.18953a.47831.47831,0,1,1-.47584.80518,1.83958,1.83958,0,0,1,.30805.50657.62277.62277,0,0,1-.05849.56923.81241.81241,0,0,1-.93817.11421c-.10256-.03942-.20574-.08534-.30971-.12734.00208.03644.00486.07294.00912.10949a1.74381,1.74381,0,0,0,.74329,1.19224,2.31227,2.31227,0,0,0-1.47506.77677,2.35285,2.35285,0,0,0-.09707,2.82155,4.11168,4.11168,0,0,0-2.02431-.3354,1.41319,1.41319,0,0,0-1.2405,1.41121c.11469.87821,1.20216,1.19932,2.08111,1.30819a85.10552,85.10552,0,0,0,20.81268-.0025,7.75118,7.75118,0,0,0,2.71365-.69035,2.79365,2.79365,0,0,0,1.57758-2.18272A2.83451,2.83451,0,0,0,497.90759,399.24114Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#6c63ff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M503.03785,409.4148a1.50028,1.50028,0,0,0-1.46892-1.16308c-.668.01756-1.26507.49459-1.921.39016-.5447-.08672-.97256-.56219-1.52037-.4896-.5017.06648-.77144.55681-1.14605.82058h-.96094c-.37411-.29449-.55794-.89114-1.07678-1.05843-.78159-.252-1.40864.62991-2.22718.78593a2.37176,2.37176,0,0,1-1.37368-.2623,4.10374,4.10374,0,0,0-1.32319-.448,1.09165,1.09165,0,0,0-1.06678.46843c.02544-.24956-.29884-.49425-.62815-.51a2.09367,2.09367,0,0,0-1.03742.31957,1.95989,1.95989,0,0,1-1.04377.29856c-.81774-.07122-1.21873-1.02669-2.041-1.03709-1.035-.01309-1.44908,1.46125-2.4726,1.33558-.53224-.06536-.81946-.54861-1.294-.75529a2.72126,2.72126,0,0,0-1.54773-.01511l-2.42077.45317a4.22941,4.22941,0,0,1-2.17116.02131c-.51925-.18786-1.02359-.5947-1.559-.43985-.46633.13486-.694.65719-1.18778.68433a2.32834,2.32834,0,0,1-.89316-.30567,1.37679,1.37679,0,0,0-1.47989.37329,8.3934,8.3934,0,0,0-.129,3.3733,3.26586,3.26586,0,0,0,.05643.71316l2.43475,9.74323c.28626,1.49428,1.02515,2.57473,2.5466,2.57473h23.6641a3.17144,3.17144,0,0,0,3.1148-2.57473l2.43475-9.74323c.00483-.02524.00794-.05032.01216-.0755A13.68562,13.68562,0,0,0,503.03785,409.4148Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M474.10479,408.68156l.47313,6.15c.15771,2.05-.07574,4.07155.082,6.12156.08883,1.15459.56881,2.33766.65763,3.49226.01045.13585.22361.137.21308,0l-.47313-6.15-.47313-6.15-.26648-3.4638c-.01045-.13585-.22361-.137-.21307,0Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.2144,408.92505l.18437,6.06033.18437,6.06033.1035,3.40228c.00417.1368.21726.13739.21308,0l-.18437-6.06032-.18437-6.06033-.1035-3.40229C478.42331,408.78825,478.21022,408.78767,478.2144,408.92505Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.1958,409.28861l-.05607,5.85687-.05573,5.82137-.03161,3.30115a.1066.1066,0,0,0,.21308,0l.05607-5.85687.05573-5.82137.03161-3.30115a.1066.1066,0,0,0-.21308,0Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.20356,409.10944l.1166,5.9292.11592,5.8937.06564,3.3374a.1066.1066,0,0,0,.21307,0l-.11661-5.9292-.11592-5.8937-.06563-3.3374a.1066.1066,0,0,0-.21308,0Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.58692,408.866l.13332,6.08733.13332,6.08733.07462,3.40749a.1066.1066,0,0,0,.21308,0l-.13332-6.08733-.13332-6.08733L489.8,408.866A.1066.1066,0,0,0,489.58692,408.866Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.22569,409.05053l.4647,6.13349.46337,6.11581.26115,3.44678c.01029.13588.22345.137.21307,0l-.4647-6.13349-.46337-6.11582-.26114-3.44677C493.42847,408.91465,493.21531,408.91353,493.22569,409.05053Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.26905,409.76531l.2802,5.61206c.09339,1.87069-.3814,3.74138-.288,5.61207l.15734,3.15125c.00681.13647.21993.13728.21308,0-.0934-1.87069.3814-3.74138.288-5.61207l-.28019-5.61206-.15734-3.15125C497.47531,409.62884,497.26219,409.628,497.26905,409.76531Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 296.82624,
    cy: 200.79763,
    rx: 0.81679,
    ry: 0.5682,
    fill: "#e6e6e6"
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 302.01107,
    cy: 202.07608,
    rx: 0.81679,
    ry: 0.5682,
    fill: "#3f3d56"
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 294.76651,
    cy: 204.84606,
    rx: 0.81679,
    ry: 0.5682,
    fill: "#ff6584"
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.52071,
    cy: 205.80405,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#e6e6e6"
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 304.79752,
    cy: 206.61203,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#3f3d56"
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300.21896,
    cy: 208.36265,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#ff6584"
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 306.35041,
    cy: 207.79275,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#e6e6e6"
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 309.62723,
    cy: 208.60073,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#3f3d56"
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 305.04867,
    cy: 210.35136,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#ff6584"
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 480.78518,
    cy: 399.23258,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(-168.43193 628.00135) rotate(-82.15499)",
    fill: "#e6e6e6"
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 479.5375,
    cy: 402.36844,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(-172.61582 629.47318) rotate(-82.15499)",
    fill: "#3f3d56"
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 478.4282,
    cy: 397.59378,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(-168.84374 624.25131) rotate(-82.15499)",
    fill: "#ff6584"
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 486.39616,
    cy: 397.52798,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(-161.89817 632.08788) rotate(-82.15499)",
    fill: "#e6e6e6"
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 485.14848,
    cy: 400.66384,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(-166.08206 633.55971) rotate(-82.15499)",
    fill: "#3f3d56"
  })), _ellipse63 || (_ellipse63 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 484.03918,
    cy: 395.88918,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(-162.30998 628.33785) rotate(-82.15499)",
    fill: "#ff6584"
  })), _ellipse64 || (_ellipse64 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 487.91846,
    cy: 394.05851,
    rx: 0.51621,
    ry: 0.3591,
    transform: "matrix(0.13649, -0.99064, 0.99064, 0.13649, -157.14666, 630.60002)",
    fill: "#3f3d56"
  })), _ellipse65 || (_ellipse65 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 486.80916,
    cy: 389.28385,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(-153.37457 625.37816) rotate(-82.15499)",
    fill: "#ff6584"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M688.19726,419.08006H666.46582c-.584,0-3.801-1.70175-3.801-3.801v-12.072c-.10393-9.13106,29.78879-9.72873,29.90156,0v12.072C692.56642,417.37832,690.29647,419.08006,688.19726,419.08006Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#e6e6e6"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M689.32177,395.02424a8.31754,8.31754,0,0,0-3.29132-.47174,2.233,2.233,0,0,0,.80588-.47223,3.26693,3.26693,0,0,1-.60654-.08172,1.4183,1.4183,0,0,1-.60312-.26983.67045.67045,0,0,1-.2529-.58648c.04062-.27612.29862-.50344.27213-.78126-.03037-.3184-.39774-.47335-.59435-.72563a1.03454,1.03454,0,0,1,.10373-1.24116,2.13853,2.13853,0,0,1,.67239-.52266,2.51135,2.51135,0,0,0-1.32.01913,1.46224,1.46224,0,0,0,.52141-1.51926,2.23268,2.23268,0,0,0-1.54173-1.42864,6.591,6.591,0,0,0-2.1751-.17565c.62028-.19057.52677-1.16231.05265-1.60533s-1.15225-.628-1.59936-1.09828-.41093-1.4742.23325-1.55229l-.0792-.22917a2.47959,2.47959,0,0,0-3.28962,1.79232c-.11805.7353.10187,1.54865-.26707,2.19557-.47037.82478-1.61218.91809-2.55725.82667a3.66915,3.66915,0,0,0-2.74222.37428,1.61759,1.61759,0,0,0,1.07988,2.85986,7.4936,7.4936,0,0,0-1.84243.24319l.57949.22459a.95148.95148,0,0,1,.349.196.32484.32484,0,0,1,.07789.36824c-.09266.168-.33206.1622-.52177.13366l-1.25985-.18953a.47831.47831,0,1,1-.47584.80518,1.83958,1.83958,0,0,1,.308.50657.62274.62274,0,0,1-.05849.56923.81241.81241,0,0,1-.93817.11421c-.10255-.03942-.20574-.08534-.3097-.12734.00208.03644.00485.07294.00912.10949a1.74374,1.74374,0,0,0,.74329,1.19224,2.31225,2.31225,0,0,0-1.47506.77677,2.35284,2.35284,0,0,0-.09707,2.82155,4.1117,4.1117,0,0,0-2.02432-.3354,1.4132,1.4132,0,0,0-1.2405,1.41121c.1147.87821,1.20217,1.19932,2.08112,1.30819a85.10544,85.10544,0,0,0,20.81267-.0025,7.75117,7.75117,0,0,0,2.71365-.69034,2.79366,2.79366,0,0,0,1.57759-2.18273A2.83453,2.83453,0,0,0,689.32177,395.02424Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#6c63ff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M694.452,405.1979a1.5003,1.5003,0,0,0-1.46892-1.16308c-.668.01756-1.26508.49459-1.921.39016-.54469-.08672-.97255-.56219-1.52036-.4896-.5017.06648-.77145.55681-1.14605.82058h-.96094c-.37411-.29448-.55795-.89114-1.07679-1.05843-.78158-.252-1.40863.62992-2.22718.78594a2.37181,2.37181,0,0,1-1.37367-.26231,4.10414,4.10414,0,0,0-1.32319-.448,1.09165,1.09165,0,0,0-1.06678.46843c.02543-.24956-.29885-.49425-.62816-.51a2.09374,2.09374,0,0,0-1.03742.31957,1.95986,1.95986,0,0,1-1.04377.29856c-.81773-.07122-1.21873-1.02669-2.041-1.03709-1.035-.01309-1.44908,1.46125-2.4726,1.33558-.53223-.06535-.81945-.54861-1.294-.75529a2.72135,2.72135,0,0,0-1.54773-.01511l-2.42078.45317a4.22938,4.22938,0,0,1-2.17115.02131c-.51925-.18786-1.0236-.5947-1.559-.43985-.46634.13486-.694.65719-1.18778.68433a2.32823,2.32823,0,0,1-.89316-.30567,1.37681,1.37681,0,0,0-1.47989.37329,8.39336,8.39336,0,0,0-.129,3.3733,3.26587,3.26587,0,0,0,.05644.71316l2.43475,9.74323c.28626,1.49428,1.02515,2.57473,2.54659,2.57473h23.66411a3.17145,3.17145,0,0,0,3.1148-2.57473l2.43474-9.74323c.00483-.02524.00794-.05032.01217-.0755A13.68653,13.68653,0,0,0,694.452,405.1979Z",
    transform: "translate(-188.09678 -193.02393)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M665.519,404.46466l.47313,6.15c.15771,2.05-.07573,4.07155.082,6.12156.08882,1.1546.5688,2.33766.65763,3.49226.01045.13585.22361.137.21307,0l-.47313-6.15-.47313-6.15-.26647-3.4638c-.01045-.13584-.22361-.137-.21308,0Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.62857,404.70815l.18437,6.06033.18437,6.06033.10351,3.40228c.00416.1368.21725.13739.21307,0l-.18436-6.06032-.18438-6.06033-.1035-3.40229C669.83749,404.57135,669.6244,404.57077,669.62857,404.70815Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.61,405.07171l-.05608,5.85687-.05573,5.82137-.0316,3.30115a.1066.1066,0,0,0,.21307,0l.05607-5.85687.05574-5.82137.0316-3.30115a.1066.1066,0,0,0-.21307,0Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.61773,404.89254l.11661,5.9292.11591,5.8937.06564,3.3374a.1066.1066,0,0,0,.21307,0l-.11661-5.9292-.11591-5.8937-.06564-3.3374a.1066.1066,0,0,0-.21307,0Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.00109,404.64907l.13332,6.08733.13332,6.08733.07463,3.40749a.1066.1066,0,0,0,.21307,0l-.13332-6.08733-.13331-6.08733-.07463-3.40749A.10661.10661,0,0,0,681.00109,404.64907Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.63987,404.83363l.4647,6.13349.46336,6.11581.26115,3.44678c.0103.13588.22345.137.21308,0l-.46471-6.13349-.46336-6.11582-.26115-3.44677C684.84265,404.69775,684.62949,404.69664,684.63987,404.83363Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.68322,405.54841l.2802,5.61206c.0934,1.87069-.3814,3.74138-.288,5.61207l.15733,3.15125c.00682.13647.21993.13729.21308,0-.0934-1.87069.3814-3.74138.288-5.61206l-.2802-5.61206-.15733-3.15126C688.88948,405.41194,688.67637,405.41113,688.68322,405.54841Z",
    transform: "translate(-188.09678 -193.02393)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _ellipse66 || (_ellipse66 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 488.24041,
    cy: 196.58073,
    rx: 0.81679,
    ry: 0.5682,
    fill: "#e6e6e6"
  })), _ellipse67 || (_ellipse67 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 493.42524,
    cy: 197.85918,
    rx: 0.81679,
    ry: 0.5682,
    fill: "#3f3d56"
  })), _ellipse68 || (_ellipse68 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 486.18068,
    cy: 200.62916,
    rx: 0.81679,
    ry: 0.5682,
    fill: "#ff6584"
  })), _ellipse69 || (_ellipse69 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 492.93488,
    cy: 201.58715,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#e6e6e6"
  })), _ellipse70 || (_ellipse70 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 496.2117,
    cy: 202.39513,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#3f3d56"
  })), _ellipse71 || (_ellipse71 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 491.63314,
    cy: 204.14576,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#ff6584"
  })), _ellipse72 || (_ellipse72 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 497.76459,
    cy: 203.57585,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#e6e6e6"
  })), _ellipse73 || (_ellipse73 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 501.0414,
    cy: 204.38383,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#3f3d56"
  })), _ellipse74 || (_ellipse74 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 496.46284,
    cy: 206.13446,
    rx: 0.51621,
    ry: 0.3591,
    fill: "#ff6584"
  })), _ellipse75 || (_ellipse75 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 672.19936,
    cy: 395.01568,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(1.03282 813.98275) rotate(-82.15499)",
    fill: "#e6e6e6"
  })), _ellipse76 || (_ellipse76 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 670.95167,
    cy: 398.15154,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(-3.15107 815.45457) rotate(-82.15499)",
    fill: "#3f3d56"
  })), _ellipse77 || (_ellipse77 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 669.84237,
    cy: 393.37688,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(0.62102 810.23271) rotate(-82.15499)",
    fill: "#ff6584"
  })), _ellipse78 || (_ellipse78 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 677.81034,
    cy: 393.31108,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(7.56659 818.06928) rotate(-82.15499)",
    fill: "#e6e6e6"
  })), _ellipse79 || (_ellipse79 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 676.56265,
    cy: 396.44694,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(3.38269 819.54111) rotate(-82.15499)",
    fill: "#3f3d56"
  })), _ellipse80 || (_ellipse80 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 675.45335,
    cy: 391.67228,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(7.15478 814.31924) rotate(-82.15499)",
    fill: "#ff6584"
  })), _ellipse81 || (_ellipse81 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 679.33263,
    cy: 389.84161,
    rx: 0.51621,
    ry: 0.3591,
    transform: "matrix(0.13649, -0.99064, 0.99064, 0.13649, 12.3181, 816.58142)",
    fill: "#3f3d56"
  })), _ellipse82 || (_ellipse82 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 678.22333,
    cy: 385.06695,
    rx: 0.51621,
    ry: 0.3591,
    transform: "translate(16.09019 811.35955) rotate(-82.15499)",
    fill: "#ff6584"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/Icon6.f206d0881c6f1438edd512cae9ffc310.svg";
export { ForwardRef as ReactComponent };